export const peso = (n) =>
  new Intl.NumberFormat("en-PH", { style: "currency", currency: "PHP" }).format(n || 0);

export const num = (n) => new Intl.NumberFormat("en-PH").format(n || 0);

export const fmtDate = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-PH", {
        timeZone: "Asia/Manila",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      })
    : "—";

export const fmtDay = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString("en-PH", {
        timeZone: "Asia/Manila",
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "—";

export const UNITS = ["kg", "g", "L", "mL", "pcs", "sack", "tray", "bottle", "case"];
export const WASTAGE_REASONS = ["spoilage", "breakage", "over-prep", "staff meal"];
export const CATEGORIES = ["Meat", "Seafood", "Vegetables", "Dry Goods", "Condiments", "Dairy & Eggs", "Beverages", "Packaging", "Other"];
